import React, { useState } from "react";
import { BsChevronDoubleRight } from "react-icons/bs";
import Testemonile from "../../containers/Testemonile/Testemonile";
import img1 from "../../images/AboutUs/hero-right1.8e5a74e5612b59faa521.png";
// import teamimages
import person1 from "../../images/AboutUs/team/person1.avif";
import person2 from "../../images/AboutUs/team/person2.avif";
import person3 from "../../images/AboutUs/team/person3.avif";
import person4 from "../../images/AboutUs/team/person4.avif";
import offerman from "../../images/AboutUs/offerman.png";
import "./About.scss";
import ScrollTrigger from "react-scroll-trigger";
import CountUp from "react-countup";
// animate count numbera
const About = () => {
  const [onCounter, setonCounter] = useState(false);
  return (
    <>
      <div className="About">
        <div className="container">
          <div className="row">
            <div className="About_Heading col-lg-6 col-md-12 col-sm-12 ">
              <h1>👋 About Us.</h1>
              <p>
                We’re impartial and independent, and every day we create
                distinctive ,world-class programmes and content which inform,
                educate and entertain millions of people in the around the
                world.
              </p>
            </div>
            <div className="About_images col-lg-6 col-md-12 col-sm-12">
              <div>
                <img src={img1} alt="About_img"></img>
              </div>
            </div>
          </div>

          {/* start div founder */}
          <div className="founder">
            <h1>⛱ Founder</h1>
            <p>
              We’re impartial and independent, and every day we create
              distinctive, world-class programmes and content
            </p>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="personteam">
                  <img src={person2} alt="teamimg"></img>
                  <h4>Niamh O'Shea</h4>
                  <p>Co-founder and Chief Executive</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="personteam">
                  <img src={person3} alt="teamimg"></img>
                  <h4>Danien Jame</h4>
                  <p>Co-founder, Chairman</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="personteam">
                  <img src={person4} alt="teamimg"></img>
                  <h4>Orla Dwyer</h4>
                  <p>Co-founder and Chief Executive</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="personteam">
                  <img src={person1} alt="teamimg"></img>
                  <h4>Dara Frazier</h4>
                  <p>Co-Founder, Chief Strategy Officer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* start testemonile */}
        <Testemonile />
        {/* start fast facts */}
        <div className="fastfact">
          <ScrollTrigger
            onEnter={() => setonCounter(true)}
            onExit={() => setonCounter(false)}
          >
            <div className="container">
              <h1>🚀 Fast Facts</h1>
              <p>
                We’re impartial and independent, and every day we create
                distinctive, world-class programmes and content
              </p>
              <div className="row">
                <div className="col-lg-4">
                  <div className="fact_content">
                    <h3>
                      {onCounter && (
                        <CountUp
                          start={0}
                          end={1312}
                          duration={1}
                          delay={0}
                        ></CountUp>
                      )}
                      k
                    </h3>
                    <p>Registered users account (as of Sept. 30, 2021)</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="fact_content">
                    <h3>
                      {onCounter && (
                        <CountUp
                          start={0}
                          end={176}
                          duration={2}
                          delay={0}
                        ></CountUp>
                      )}
                      k
                    </h3>
                    <p>our sproducts in store all over the world</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="fact_content">
                    <h3>
                      {onCounter && (
                        <CountUp
                          start={0}
                          end={23}
                          duration={3}
                          delay={0}
                        ></CountUp>
                      )}
                      k
                    </h3>
                    <p>
                      Countries and regions have our presence (as of Sept. 30,
                      2021)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollTrigger>
        </div>
        {/* start dont miss offers div */}
        <div className="container">
          <div className="special_offers">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <h3>Don't miss out on special offers </h3>
                <p>
                  Register to receive news about the latest, savings combos,
                  discount codes...
                </p>
                <ul>
                  <li>
                    <span
                      style={{ backgroundColor: "#F3E8FF", color: "#7D21A8" }}
                    >
                      01
                    </span>
                    Savings combos
                  </li>
                  <li>
                    <span
                      style={{ backgroundColor: "#DBEAFE", color: "#3068c6" }}
                    >
                      02
                    </span>
                    Freeship
                  </li>
                  <li>
                    <span
                      style={{ backgroundColor: "#FEE2E2", color: "#B31B1B" }}
                    >
                      03
                    </span>
                    Premium magazines
                  </li>
                </ul>
                <form>
                  <input
                    type="email"
                    required
                    aria-required="true"
                    placeholder="Enter your email"
                  ></input>
                  <button className="Submit">
                    <BsChevronDoubleRight />
                  </button>
                </form>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <img src={offerman} alt="special_offers"></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
